<template>
  <BooksAlerts />
  <RouterView data-app v-bind="$attrs" :data-display-theme="theme" />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';

import BooksAlerts from '@/js/components/alerts.vue';
import { useUserStore } from '@/js/stores/user';

export default defineComponent({
  name: 'BooksRoot',
  components: {
    BooksAlerts,
  },
  setup() {
    const userStore = useUserStore();
    const theme = computed(() => userStore.user?.display_theme ?? null);

    return { theme };
  },
});
</script>

<style lang="scss">
@use '@/sass/app';
</style>
